import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

export const ReviewCard = ({ review }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white p-6 rounded-2xl border border-stone-200 shadow-card"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-terracotta/20 rounded-full flex items-center justify-center">
            <span className="text-terracotta font-semibold">
              {review.user_name?.[0]?.toUpperCase()}
            </span>
          </div>
          <div>
            <h4 className="font-medium text-navy">{review.user_name}</h4>
            <p className="text-xs text-navy/50">
              {new Date(review.created_at).toLocaleDateString('fr-CH')}
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-1">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              size={16}
              className={
                i < review.rating
                  ? 'fill-ocre text-ocre'
                  : 'text-stone-300'
              }
            />
          ))}
        </div>
      </div>
      
      <p className="text-navy/70 text-sm leading-relaxed">
        {review.comment}
      </p>
    </motion.div>
  );
};

export const StarRating = ({ rating, setRating, readonly = false }) => {
  return (
    <div className="flex items-center space-x-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={readonly}
          onClick={() => !readonly && setRating(star)}
          className={`p-1 ${!readonly && 'hover:scale-110 transition-transform cursor-pointer'}`}
          data-testid={`star-${star}`}
        >
          <Star
            size={24}
            className={
              star <= rating
                ? 'fill-ocre text-ocre'
                : 'text-stone-300'
            }
          />
        </button>
      ))}
    </div>
  );
};
